<div class="text-center">
  <h1>Admin oldal</h1>
  <p>Kérjük jelentkezz be, hogy láthasd az előzetes időpont foglalásokat.</p>
  <button id="googleBtn" class="default-button" #googleBtn (click)="login()">Belépés</button>
</div>
